<template>
  <div>
    <div class="blockC matching-box clearfix" style="margin-top: 20px">
      <div class="blockC-detail">
        <div class="blockC-tip"></div>
        <span class="blockC-title">物流信息：</span>
      </div>
      <vxe-form
          style="margin-top: 10px;"
          ref="logistics"
          class="my-form"
          title-align="right"
          :data="formData"
          :rules="bsType !== 2 ? formRules2:formRules1"
          title-width="120"
          prevent-submit>
        <vxe-form-item title="车船号" field="carShipNum" span="8">
          <template v-slot>
            <div :class="carShipCheck ? 'input-border border-red' : 'input-border'">
              <a class="sel-link" @click="openCarShip()" target="_black">
                {{!formData.carShipNum || formData.carShipNum === null || formData.carShipNum === "" ? "请选择" :
                formData.carShipNum}}</a>
            </div>
          </template>
        </vxe-form-item>
        <vxe-form-item title="起运地(省)" field="beginPlacePro" span="8" v-if="bsType === 2">
          <template v-slot>
            <vxe-select v-model="formData.beginPlacePro" :options="cityData"
                        @change="loadbeginPlaceCity(formData.beginPlacePro, 1)"
                        @focus="clearValidate()"
                        placeholder="请选择" transfer></vxe-select>
          </template>
        </vxe-form-item>
        <vxe-form-item title="起运地(市)" field="beginPlaceCity" span="8" v-if="bsType === 2">
          <template v-slot>
            <vxe-select v-model="formData.beginPlaceCity" :options="beginPlaceCityOptions" placeholder="请选择"
                        @change="loadbeginPlaceArea(formData.beginPlacePro, formData.beginPlaceCity, 1)"
                        @focus="clearValidate()" transfer></vxe-select>
          </template>
        </vxe-form-item>
        <vxe-form-item title="起运地(区)" field="beginPlaceArea" span="8" v-if="bsType === 2">
          <template v-slot>
            <vxe-select v-model="formData.beginPlaceArea" :options="beginPlaceAreaOptions" @focus="clearValidate()"
                        placeholder="请选择" transfer></vxe-select>
          </template>
        </vxe-form-item>
        <vxe-form-item v-if="bsType === 2" title="详细地址" field="beginPlaceDetail" span="8">
          <template v-slot>
            <vxe-input v-model="formData.beginPlaceDetail" placeholder="起运地" @focus="clearValidate()"></vxe-input>
          </template>
        </vxe-form-item>
        <vxe-form-item v-if="bsType !== 2" title="起运地" field="beginPlaceDetail" span="8">
          <template v-slot>
            <vxe-input v-model="formData.beginPlaceDetail" placeholder="起运地" @focus="clearValidate()"></vxe-input>
          </template>
        </vxe-form-item>
        <vxe-form-item v-if="bsType !== 2" title="到达地" field="endPlaceDetail" span="8">
          <template v-slot>
            <vxe-input v-model="formData.endPlaceDetail" placeholder="到达地" @focus="clearValidate()"></vxe-input>
          </template>
        </vxe-form-item>
        <vxe-form-item title="起运时间" field="beginTime" span="8">
          <template v-slot>
            <vxe-input v-model="formData.beginTime" placeholder="请选择时间" @change="clearValidate()"
                       :type="bsType === 2 ? 'datetime' : 'date'" transfer></vxe-input>
          </template>
        </vxe-form-item>
        <vxe-form-item title="浮动天数(天)" field="beginTimeDay" span="8" v-if="bsType !== 2">
          <template v-slot>
            <vxe-input v-model="formData.beginTimeDay" type="integer" placeholder="请输入浮动天数"
                       @focus="clearValidate()"></vxe-input>
          </template>
        </vxe-form-item>
        <vxe-form-item title="到达地(省)" field="endPlacePro" span="8" v-if="bsType === 2">
          <template v-slot>
            <vxe-select v-model="formData.endPlacePro" :options="cityData "
                        @change="loadbeginPlaceCity(formData.endPlacePro, 2)"
                        @focus="clearValidate()"
                        placeholder="请选择" transfer></vxe-select>
          </template>
        </vxe-form-item>
        <vxe-form-item title="到达地(市)" field="endPlaceCity" span="8" v-if="bsType === 2">
          <template v-slot>
            <vxe-select v-model="formData.endPlaceCity" :options="endPlaceCityOptions" placeholder="请选择"
                        @change="loadbeginPlaceArea(formData.endPlacePro, formData.endPlaceCity, 2)"
                        @focus="clearValidate()" transfer></vxe-select>
          </template>
        </vxe-form-item>
        <vxe-form-item title="到达地(区)" field="endPlaceArea" span="8" v-if="bsType === 2">
          <template v-slot>
            <vxe-select v-model="formData.endPlaceArea" :options="endPlaceAreaOptions" @focus="clearValidate()"
                        placeholder="请选择" transfer></vxe-select>
          </template>
        </vxe-form-item>
        <vxe-form-item v-if="bsType === 2" title="详细地址" field="endPlaceDetail" span="8">
          <template v-slot>
            <vxe-input v-model="formData.endPlaceDetail" placeholder="到达地" @focus="clearValidate()"></vxe-input>
          </template>
        </vxe-form-item>
        <vxe-form-item title="到达时间" field="endTime" span="8" v-if="bsType === 2">
          <template v-slot>
            <vxe-input v-model="formData.endTime" placeholder="请选择时间" @change="clearValidate()"
                       :type="bsType === 2 ? 'datetime' : 'date'" transfer></vxe-input>
          </template>
        </vxe-form-item>
      </vxe-form>
    </div>
    <vxe-modal class="carShipModal" v-model="carShipVisible" title="选择车船" width="1300" height="600" resize
               position="center">
      <choose-car-ship
          ref="carShipModal"
          @choose="chooseCarShip"
      ></choose-car-ship>
    </vxe-modal>
  </div>

</template>

<script>
  import {isEmpty, isNotEmpty} from "@/utils/util";
  import ChooseCarShip from "@/components/modal/ChooseCarShip";

  var appData = require("@/assets/json/zz.json");

  export default {
    props: ['busType', 'cityData', 'isSubmit', 'isCancel', 'isSave', 'detailData'],
    components: {ChooseCarShip},
    data() {
      return {
        formData: {
          carShipNum: null,
          beginPlacePro: null,
          beginPlaceCity: null,
          beginPlaceArea: null,
          beginPlaceDetail: null,
          beginTime: null,
          beginTimeDay: null,
          endPlacePro: null,
          endPlaceCity: null,
          endPlaceArea: null,
          endPlaceDetail: null,
          endTime: null
        },
        formRules1: {
          carShipNum: [{required: true, message: '请选择车船号'}],
          beginPlacePro: [{required: true, message: '请选择起运地(省)'}],
          beginPlaceCity: [{required: true, message: '请选择起运地(市)'}],
          beginPlaceArea: [{required: true, message: '请选择起运地(区)'}],
          beginPlaceDetail: [{required: true, message: '输入详细地址'}],
          beginTime: [{required: true, message: '请选择起运时间'}],
          endPlacePro: [{required: true, message: '请选择到达地(省)'}],
          endPlaceCity: [{required: true, message: '请选择到达地(市)'}],
          endPlaceArea: [{required: true, message: '请选择到达地(区)'}],
          endPlaceDetail: [{required: true, message: '请输入详细地址'}],
        },
        formRules2: {
          carShipNum: [{required: true, message: '请选择车船号'}],
          beginPlaceDetail: [{required: true, message: '请输入起运地'}],
          beginTime: [{required: true, message: '请选择起运时间'}],
          endPlaceDetail: [{required: true, message: '请输入到达地'}],
        },
        beginPlaceCityData: [],
        beginPlaceCityOptions: [],
        endPlaceCityOptions: [],
        beginPlaceAreaOptions: [],
        endPlaceAreaOptions: [],
        carShipVisible: false,
        bsType: null,
        carShipCheck: false
      };
    },
    watch: {
      busType(val) {
        if (val) {
          this.bsType = val;
        }
      },
      isSubmit(val) {
        if (val) {
          this.check();
        }
      },
      isCancel(val) {
        if (val) {
          this.reset();
        }
      },
      isSave(val) {
        if (val) {
          this.setParams();
        }
      },
      detailData(val) {
        if (val) {
          this.bsType = this.detailData.contractType;
          this.formData = {
            carShipId: this.detailData.carShipId,
            carShipType: this.detailData.carShipType,
            carShipNum: this.detailData.carShipNum,
            beginPlacePro: this.detailData.beginPlacePro,
            beginPlaceCity: this.detailData.beginPlaceCity,
            beginPlaceArea: this.detailData.beginPlaceArea,
            beginPlaceDetail: this.detailData.beginPlaceDetail,
            beginTime: this.detailData.beginTime ? this.$utils.toStringDate(this.detailData.beginTime) : null,
            beginTimeDay: this.detailData.beginTimeDay,
            endPlacePro: this.detailData.endPlacePro,
            endPlaceCity: this.detailData.endPlaceCity,
            endPlaceArea: this.detailData.endPlaceArea,
            endPlaceDetail: this.detailData.endPlaceDetail,
            endTime: this.detailData.endTime ? this.$utils.toStringDate(this.detailData.endTime) : null,
          }
        }
      }
    },
    methods: {
      async check() {
        const errMap = await this.$refs.logistics.validate().catch(errMap => errMap);
        if (errMap) {
          if (!this.formData.carShipNum || this.formData.carShipNum === '') {
            this.carShipCheck = true;
          } else {
            this.carShipCheck = false;
          }
          this.$emit("setParams", false);
          return
        }
        this.carShipCheck = false;
        this.setParams();
      },
      setParams() {
        let beginPlace = '';
        let endPlace = '';
        if (this.formData.beginPlacePro) {
          beginPlace = beginPlace + this.formData.beginPlacePro;
        }
        if (this.formData.beginPlaceCity) {
          beginPlace = beginPlace + this.formData.beginPlaceCity;
        }
        if (this.formData.beginPlaceArea) {
          beginPlace = beginPlace + this.formData.beginPlaceArea;
        }
        if (this.formData.beginPlaceDetail) {
          beginPlace = beginPlace + this.formData.beginPlaceDetail;
        }
        if (this.formData.endPlacePro) {
          endPlace = endPlace + this.formData.endPlacePro;
        }
        if (this.formData.endPlaceCity) {
          endPlace = endPlace + this.formData.endPlaceCity;
        }
        if (this.formData.endPlaceArea) {
          endPlace = endPlace + this.formData.endPlaceArea;
        }
        if (this.formData.endPlaceDetail) {
          endPlace = endPlace + this.formData.endPlaceDetail;
        }
        // 过滤参数
        let obj = {
          carShipId: this.formData.carShipId,
          carShipType: this.formData.carShipType,
          carShipNum: this.formData.carShipNum,
          beginPlacePro: this.formData.beginPlacePro,
          beginPlaceCity: this.formData.beginPlaceCity,
          beginPlaceArea: this.formData.beginPlaceArea,
          beginPlaceDetail: this.formData.beginPlaceDetail,
          beginPlace: beginPlace,
          beginTime: this.formData.beginTime ? this.$utils.timestamp(this.formData.beginTime) : null,
          beginTimeDay: this.formData.beginTimeDay,
          endPlacePro: this.formData.endPlacePro,
          endPlaceCity: this.formData.endPlaceCity,
          endPlaceArea: this.formData.endPlaceArea,
          endPlaceDetail: this.formData.endPlaceDetail,
          endTime: this.formData.endTime ? this.$utils.timestamp(this.formData.endTime) : null,
          endPlace: endPlace
        };
        this.$emit("setParams", obj);
      },
      async openCarShip() {
        this.carShipVisible = true;
        this.$refs.carShipModal.init(this.bsType ? (this.bsType === 2 ? 2 : 1) : null);
      },
      chooseCarShip(row, type) {
        if (type === "ship") {
          this.formData.carShipType = 2;
          this.formData.carShipNum = row.shipName;
          this.formData.carShipId = row.id;
          this.$emit('setShipInfo', row)
        } else {
          this.formData.carShipType = 1;
          this.formData.carShipNum = row.carNum;
          this.formData.carShipId = row.id;
        }
        this.$refs.carShipModal.close();
        this.carShipVisible = false;
        this.clearValidate();
      },
      loadbeginPlaceCity(beginPlacePro, type, isImpot = false) {
        if (!isImpot) {
          if (type === 1) {
            this.formData.beginPlaceCity = "";
            this.formData.beginPlaceArea = "";
          } else {
            this.formData.endPlaceCity = "";
            this.formData.endPlaceArea = "";
          }
        }

        let beginPlaceCityOptions = appData.filter(i => i.label === beginPlacePro);
        let isHasChildren = beginPlaceCityOptions[0].children.some(m =>
          isNotEmpty(m.children)
        );
        if (isHasChildren) {
          let arr = beginPlaceCityOptions[0].children.map(i => {
            return {
              label: i.label,
              value: i.label
            };
          });
          type === 1 ? (this.beginPlaceCityOptions = arr) : (this.endPlaceCityOptions = arr);
        } else {
          let beginPlaceCityArr = [{
            label: beginPlacePro,
            value: beginPlacePro
          }];
          type === 1 ? (this.beginPlaceCityOptions = beginPlaceCityArr) : (this.endPlaceCityOptions = beginPlaceCityArr);
        }
        this.clearValidate();
      },
      loadbeginPlaceArea(beginPlacePro, beginPlaceCity, type, isImpot = false) {
        if (!isImpot) {
          if (type === 1) {
            this.formData.beginPlaceArea = "";
          } else {
            this.formData.endPlaceArea = "";
          }
        }
        let beginPlaceCityOptions = appData.filter(i => i.label === beginPlacePro);
        let arr = [];
        if (beginPlacePro === beginPlaceCity) {
          arr = beginPlaceCityOptions[0].children.map(i => {
            return {
              label: i.label,
              value: i.label
            };
          });
        } else {
          let beginPlaceAreaOptions = beginPlaceCityOptions[0].children.filter(i => i.label === beginPlaceCity);
          arr = beginPlaceAreaOptions[0].children.map(i => {
            return {
              label: i.label,
              value: i.label
            };
          });
        }
        type === 1 ? (this.beginPlaceAreaOptions = arr) : (this.endPlaceAreaOptions = arr);
        this.clearValidate();
      },
      clearValidate() {
        this.carShipCheck = false;
        this.$refs.logistics.clearValidate();
      },
      reset() {
        this.formData = {
          carShipNum: null,
          beginPlacePro: null,
          beginPlaceCity: null,
          beginPlaceArea: null,
          beginPlaceDetail: null,
          beginTime: null,
          beginTimeDay: null,
          endPlacePro: null,
          endPlaceCity: null,
          endPlaceArea: null,
          endPlaceDetail: null,
          endTime: null
        };
        this.carShipCheck = false;
        this.clearValidate();
      }
    }
  };
</script>

<style scoped>
  .input-border {
    display: flex;
    align-items: center;
    height: 100%;
    box-sizing: border-box;
    padding-left: 10px;
    border: 1px solid #f2f1f1;
  }

  .input-border >>> .link-text {
    color: #438DF3;
  }

  .border-red {
    border-color: #f56c6c;
  }

  .carShipModal >>> .vxe-modal--box .vxe-modal--body {
    padding: .6em 1em !important;
    background: none !important;
  }
</style>